import React, {useRef, useState} from "react";
import { Box, Button, Column, Columns, Control, Field, Input, Notification, Title } from "@allxsmith/bestax-bulma";

import {AsyncTypeahead} from "react-bootstrap-typeahead";
import axios from "axios";
import {depCreditLimit} from "../../utils";
import CreateNewContactModal from "./CreateNewContactModal";


function ContactSection(props) {
  const [, setLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const typeahead = useRef();
  const [createModalOpen, setCreateModalOpen] = useState(false);

  const types = {
    CC: "Customer",
    SP: "Supplier"
  };

  const getCreditLimit = () =>{
      // props will need to supplier a department
      return depCreditLimit(props.contact, props.department)
  }

  const handleCustomerSelect = e => {
    typeahead.current.clear();
    props.contactUpdate(e[0]);
  };

  const handleClear = e => {
    typeahead.current.clear();
    props.contactUpdate(undefined);
  };

  const handleSearch = query => {
    setLoading(true);
    // needs a prop that can force a full search instead of min search

    const url = props.fullSearch ? '/api/contacts' : props.type === "CC" ? '/api/customersearch' : '/api/suppliersearch';

    axios
      .get(`${url}?search=${query}&page_size=40&${props.fullSearch ? "contact_type="+props.type+"&" : ""}show_deactive=${(!!props.showDeactivated)}`)
      .then(resp => {
        setSearchData(resp.data.results);
        setLoading(false);
      });
  };

  return (
    <Box className="contact-section">
      <Columns isMultiline>
        <Column>
          <h1 className="title">{props.title}</h1>
        </Column>

        {props.type === "CC" && !props.print && (
          <Column>
            <Button
              tabIndex={-1}
              onClick={() => setCreateModalOpen(true)}
              color="success"
              className="is-pulled-right"
              disabled={props.disabled}
            >
              Add a new Customer +
            </Button>
          </Column>
        )}
        {props.contact.id &&
          <Column>
            <Button
              tabIndex={-1}
              onClick={() => window.open(`/editcontact/${props.contact.id}`, "_blank")}
              color="info"
              className="is-pulled-right"
            >
              Contact Details
            </Button>
          </Column>
        }
        <Column>
          <Button
            tabIndex={-1}
            onClick={handleClear}
            color="warning"
            className="is-pulled-right"
            disabled={props.disabled}
          >
            Clear
          </Button>
        </Column>
      </Columns>
      {!props.print && (
        <AsyncTypeahead
          useCache={false}
          isLoading={false}
          id="typeahead"
          labelKey="display_name"
          minLength={2}
          name={"display_name"}
          onSearch={handleSearch}
          onChange={handleCustomerSelect}
          placeholder={`Search ${types[props.type]}`}
          options={searchData}
          ref={typeahead }
          className="typeahead"
          disabled={props.disabled}
        />
      )}
      <Columns isMultiline>
        <Column>
          <Field>
            <label className="label">Name</label>
            <Input
              type="text"
              name="display_name"
              // onChange={this.handleChange}
              value={props.contact.display_name}
              readOnly
              disabled
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Contact Number</label>
            <Input
              type="text"
              name="company_phone"
              // onChange={this.handleChange}
              value={props.contact.company_phone}
              readOnly
              disabled
            />
          </Field>
        </Column>
        {!props.print && (
          <Column>
            <Field>
              <label className="label">Email</label>
              <Input
                type="text"
                name="company_email"
                value={props.contact.company_email}
                readOnly
                disabled
              />
            </Field>
          </Column>
        )}
      </Columns>
      {props.print && (
        <Columns isMultiline>
          <Column>
            <Field>
              <label className="label">Email</label>
              <Input
                type="text"
                name="email"
                value={props.contact.company_email}
                readOnly
                disabled
              />
            </Field>
          </Column>
        </Columns>
      )}
      <Columns isMultiline>
        <Column>
          <Field>
            <label className="label">Address</label>
            <pre>{`${props.contact.address_line1 || ""}\n${props.contact.town ||
            ""}\n${props.contact.postcode || ""}`}</pre>
          </Field>
        </Column>
      </Columns>
      {props.contact.id && props.displayWorkshopInstructions && !props.contact.accounts_active &&
        <Notification
          className="clickable"
          onClick={() => window.open(`/editcontact/${props.contact.id}`, "_blank")}
          color="danger">
          Warning! Account Form not received, check contact page.
        </Notification>
      }
      {props.contact.id && props.displayWorkshopInstructions && (getCreditLimit() === 0) &&
        <Notification
          className="clickable"
          onClick={() => window.open(`/editcontact/${props.contact.id}`, "_blank")}
          color="danger">
          Warning! Cash Sale!.
        </Notification>
      }
      {props.contact.id && props.contact.overdue_payment &&
        <Notification
          color="danger">
          Warning! Account has overdue payment{(props.contact.cost_centre_list || []).length ? " to " + props.contact.cost_centre_list.join(", ") : ""}.
        </Notification>
      }
      {props.displayWorkshopInstructions && props.contact.id &&
        <Columns isMultiline>
          <Column>
            <Field>
              <label className="label">Credit Limit</label>
              <Control>
                <Input
                  type="number"
                  name="credit_limit"
                  value={getCreditLimit()}
                  readOnly
                  disabled
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Account Balance</label>
              <Control>
                <Input
                  type="number"
                  name="outstanding_balance"
                  value={props.contact.outstanding_balance}
                  readOnly
                  disabled
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Payment Terms</label>
              <Input
                type="text"
                name="payment_terms"
                value={props.contact.payment_terms}
                readOnly
                disabled
              />
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Payment Method</label>
              <Input
                type="text"
                name="payment_method"
                value={props.contact.payment_method}
                readOnly
                disabled
              />
            </Field>
          </Column>
        </Columns>
      }
      {(props.displayWorkshopInstructions && props.contact.workshop_instructions && props.contact.workshop_instructions.length > 0) &&
        <Title size="6">Workshop Instructions</Title>}
      {props.displayWorkshopInstructions && props.contact.workshop_instructions && props.contact.workshop_instructions
        .filter((instruction) => !instruction.on_completion).map(instruction =>
          <Columns isMultiline>
            <Column>
              <Field>
                <Input
                  className="ws-instructions"
                  type="text"
                  name="workshop_instructions"
                  value={instruction.text}
                  readOnly
                  disabled
                />
              </Field>
            </Column>
          </Columns>
        )
      }
      {(props.displayRentalInstructions && props.contact.rental_instructions && props.contact.rental_instructions.length > 0) &&
        <Title size="6">Rental Instructions</Title>}
      {props.displayRentalInstructions && props.contact.rental_instructions && props.contact.rental_instructions
        .filter((instruction) => !instruction.on_completion).map(instruction =>
          <Columns isMultiline>
            <Column>
              <Field>
                <Input
                  className="ws-instructions"
                  type="text"
                  name="rental_instructions"
                  value={instruction.text}
                  readOnly
                  disabled
                />
              </Field>
            </Column>
          </Columns>
        )
      }
      <CreateNewContactModal
        open={createModalOpen}
        setOpen={setCreateModalOpen}
      />
    </Box>
  );
}

export default ContactSection;
